import type { gameResult } from '@/models/gameUpdate';
import { formatFixtureKickoffLondon } from '@/helpers';
import { formatRegulationScoreLine, resolvePenaltyScore } from '@/helpers/fixtures/matchScoreDisplay';
import { MatchScoreAccordionRow } from './matchRows/MatchScoreAccordionRow';

export function MatchResultRow(props: {
  result: gameResult;
  svg?: boolean;
  expandable?: boolean;
  bracketLabel?: string;
  showBracketLabel?: boolean;
  fontSize?: number;
  metaFontSize?: number;
  nameLines?: number;
}) {
  const kickoffDate = props.result.kickOffTime?.toDate() ?? props.result.timestamp?.toDate();
  const kickoff = kickoffDate ? formatFixtureKickoffLondon(kickoffDate) : '';

  return (
    <MatchScoreAccordionRow
      homeTeam={props.result.countryA}
      awayTeam={props.result.countryB}
      goalsScoreLine={formatRegulationScoreLine(props.result.goalsA, props.result.goalsB)}
      penaltyScore={resolvePenaltyScore(props.result.goalsA, props.result.goalsB, {
        wentToPens: props.result.wentToPens,
        penaltiesHome: props.result.penaltiesA,
        penaltiesAway: props.result.penaltiesB,
      })}
      metaLine={kickoff}
      events={props.result.events ?? []}
      variant='result'
      svg={props.svg}
      expandable={props.expandable}
      bracketLabel={props.bracketLabel}
      showBracketLabel={props.showBracketLabel}
      homePoints={props.result.pointsA}
      awayPoints={props.result.pointsB}
      fontSize={props.fontSize}
      metaFontSize={props.metaFontSize}
      nameLines={props.nameLines}
    />
  );
}
